import React, { FC } from 'react'

const SperatorIcon: FC = () => {
    return (
        <svg width="119" height="1" viewBox="0 0 119 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" y1="0.5" x2="119" y2="0.5" stroke="white" />
      </svg>
    )
}

export default SperatorIcon


